module.exports = __webpack_public_path__ + "static/todoist_1-85653dd5bf88792324dc89c190b7ac8e.png";